<mat-form-field class="allwidth">
    <input matInput placeholder="{{ 'IBAN' | translate}}" [value]="ngControl.control.value" [disabled]="true" class="one">
    <i matSuffix *ngIf="ngControl?.control.enabled" class="glyphicon glyphicon-new-window link" (click)="selectUserIban()"></i>
</mat-form-field>
<error [control]="ngControl?.control"></error>
